export const translate = {
    "캘린더 일정 추가": {
        ko: "캘린더 일정 추가",
        en: "Registering a calendar schedule",
    },

    제목: {
        ko: "제목",
        en: "Title",
    },

    "방문 일자": {
        ko: "방문 일자",
        en: "Date of visit",
    },

    "방문 시간": {
        ko: "방문 시간",
        en: "Time of visit",
    },

    "방문 목적": {
        ko: "방문 목적",
        en: "Purpose of visit",
    },

    참석자: {
        ko: "참석자",
        en: "Attendee",
    },

    "추가된 참석자들은 구글 캘린더 일정에 참석자로 설정됩니다.": {
        ko: "추가된 참석자들은 구글 캘린더 일정에 참석자로 설정됩니다.",
        en: "Attendees will be set to attend the Google Calendar schedule.",
    },

    "참석자 검색": {
        ko: "참석자 검색",
        en: "Search Attendee",
    },

    "이미 추가된 참석자입니다.": {
        ko: "이미 추가된 참석자입니다.",
        en: "Attendees already added.",
    },

    메모: {
        ko: "메모",
        en: "Memo",
    },

    "방문자 소속": {
        ko: "방문자 소속",
        en: "Department of visitor",
    },

    선택: {
        ko: "선택",
        en: "Optional",
    },

    "방문자 안내 언어": {
        ko: "방문자 안내 언어",
        en: "Visitor's Guide Language",
    },

    한국어: {
        ko: "한국어",
        en: "Korean",
    },

    영어: {
        ko: "영어",
        en: "English",
    },

    "방문자 정보": {
        ko: "방문자 정보",
        en: "Visitors Information",
    },

    이름: {
        ko: "이름",
        en: "Name",
    },
};
